var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100",attrs:{"id":"app"}},[_c('Header',{attrs:{"client-area":true}}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }